import { useNavigate } from "react-router-dom";
import { Header } from "@/components/Header";
import { ProjectForm } from "@/components/ProjectForm";
import { useToast } from "@/hooks/use-toast";
import { cloudflare } from "@/integrations/cloudflare/client";

interface ProjectFormData {
  projectName: string;
  customerName: string;
  email: string;
  phone: string;
  address: string;
  city: string;
  state: string;
  zip_code: string;
  country: string;
  budget: string;
  timeframe: string;
  description: string;
}

const NewProject = () => {
  const navigate = useNavigate();
  const { toast } = useToast();

  const handleProjectSubmit = async (projectId: string, projectData: ProjectFormData) => {
    try {
      // Navigate to service selection or project details
      navigate(`/projects/${projectId}`);

      toast({
        title: "Project Created",
        description: `Project for ${projectData.customerName} has been created successfully.`,
      });
    } catch (error) {
      console.error("Error handling project:", error);
      toast({
        title: "Error",
        description: "Failed to create project. Please try again.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 to-blue-50/30">
      <Header
        onNewProject={() => navigate("/new-project")}
        onViewProjects={() => navigate("/projects")}
      />

      <main className="container mx-auto px-3 sm:px-6 lg:px-8 py-4 sm:py-8">
        <div className="max-w-5xl mx-auto">
          <ProjectForm onBack={() => navigate("/dashboard")} onSubmit={handleProjectSubmit} />
        </div>
      </main>
    </div>
  );
};

export default NewProject;
